import React, { createContext, useContext, ReactNode } from 'react';

interface FormNavigationContextType {
  currentStep: number;
  totalSteps: number;
  isSliderStep: boolean;
  activeSliderTab: number;
  totalSliderTabs: number;
  handleSliderTabChange: (tab: number) => void;
  handlePrevious: () => void;
  handleNext: () => void;
}

const FormNavigationContext = createContext<
  FormNavigationContextType | undefined
>(undefined);

export const FormNavigationProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: FormNavigationContextType;
}) => {
  return (
    <FormNavigationContext.Provider value={value}>
      {children}
    </FormNavigationContext.Provider>
  );
};

export const useFormNavigation = () => {
  const context = useContext(FormNavigationContext);
  if (!context) {
    throw new Error(
      'useFormNavigation must be used within a FormNavigationProvider'
    );
  }
  return context;
};
